require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-make-elements-only-visible-to-a-screen-reader-by-using-custom-css.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-make-elements-only-visible-to-a-screen-reader-by-using-custom-css");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-make-elements-only-visible-to-a-screen-reader-by-using-custom-css!./.cache/json/responsive-web-design-applied-accessibility-make-elements-only-visible-to-a-screen-reader-by-using-custom-css.json
// module id = 2522
// module chunks = 231608221292675